export default "__VITE_ASSET__fe6a88d2__"